<template>
  <div
    :class="['wrapper', type]"
    :style="{
      top: `calc(${setyleNavHeight}px + 1rem)`
    }"
  >
    <div class="flex items-center justify-center">
      <img v-if="type === 'error'" src="./assets/error.svg" class="w-4" />
      <img v-else-if="type === 'info'" src="./assets/info.svg" class="w-4" />
      <img v-else-if="type === 'warn'" src="./assets/warn.svg" class="w-4" />
      <img v-else src="./assets/success.svg" class="w-4" />
      <span class="ml-2">{{ content }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Notification extends Vue {
  @Prop({ type: String }) content!: string;
  @Prop({ type: String }) type!: string;
  get setyleNavHeight() {
    return window.clewordNav.clewordNavVisible ? window.clewordNav.setyleNavHeight || 0 : 0;
  }
}
</script>

<style scoped>
.wrapper {
  @apply fixed left-1/2 text-center rounded-md overflow-hidden px-4 py-2 shadow-sm z-50 border;
  transform: translateX(-50%);
  transition: 0.5s;
  animation: in 0.3s ease both;
  animation-delay: 1;
}

.success {
  @apply border-motif-success;
  background-color: var(--motif-success-bg);
}

.warn {
  @apply border-motif-warn;
  background-color: var(--motif-warn-bg);
}

.error {
  @apply border-motif-error;
  background-color: var(--motif-error-bg);
}

.info {
  @apply border-motif-info;
  background-color: var(--motif-info-bg);
}

@keyframes in {
  0% {
    transform: translate(-50%, -110%);
  }
  50% {
    transform: translate(-50%, 10%);
  }
  75% {
    transform: translate(-50%, -10%);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
</style>
